import { render } from "./CardLink.vue?vue&type=template&id=3a6e4602&scoped=true"
import script from "./CardLink.vue?vue&type=script&lang=js"
export * from "./CardLink.vue?vue&type=script&lang=js"

import "./CardLink.vue?vue&type=style&index=0&id=3a6e4602&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6e4602"]])

export default __exports__